import BusinessOutlinedIcon from "@mui/icons-material/BusinessOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import { Chip, List, Skeleton, Stack, Typography } from "@mui/material";
import { MeetingDetailItem } from "./meeting-detail-item";

function EventTooltipDetailsList({
  datetime,
  ambassadorName,
  clientName,
  isLoadingUsers,
  isAmbassadorConfirmed,
}: {
  datetime: string;
  ambassadorName: string;
  clientName: string;
  isLoadingUsers: boolean;
  isAmbassadorConfirmed: boolean;
}) {
  return (
    <List disablePadding sx={{ py: 0.5 }}>
      <MeetingDetailItem
        icon={<EventOutlinedIcon sx={{ fontSize: 18 }} />}
        primary="Schedule"
        secondary={
          <Typography fontSize={13.5} fontWeight={500} color="#0F172A">
            {datetime}
          </Typography>
        }
      />
      <MeetingDetailItem
        icon={<PersonOutlinedIcon sx={{ fontSize: 18 }} />}
        primary="Ambassador"
        secondary={
          isLoadingUsers ? (
            <Skeleton width="60%" height={20} />
          ) : (
            <Stack direction="row" alignItems="center" spacing={0.75}>
              <Typography fontSize={13.5} fontWeight={500} color="#0F172A">
                {ambassadorName || "—"}
              </Typography>
              {isAmbassadorConfirmed && (
                <Chip
                  size="small"
                  icon={
                    <TaskAltRoundedIcon sx={{ fontSize: "14px !important" }} />
                  }
                  label="Confirmed"
                  sx={{
                    height: 22,
                    fontSize: 10.5,
                    fontWeight: 700,
                    bgcolor: "#ECFDF5",
                    color: "#059669",
                    "& .MuiChip-icon": { color: "#10B981" },
                  }}
                />
              )}
            </Stack>
          )
        }
      />
      <MeetingDetailItem
        icon={<BusinessOutlinedIcon sx={{ fontSize: 18 }} />}
        primary="Client"
        secondary={
          isLoadingUsers ? (
            <Skeleton width="50%" height={20} />
          ) : (
            <Typography fontSize={13.5} fontWeight={500} color="#0F172A">
              {clientName || "—"}
            </Typography>
          )
        }
      />
    </List>
  );
}

export { EventTooltipDetailsList };
